import { useState } from "react";
import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { lerErroDeBlob } from "../../lib/download";

interface BotoesExportacaoProps {
  /** Recebe o formato e devolve a promessa do download. */
  aoExportar: (formato: "pdf" | "excel") => Promise<void>;
  desabilitado?: boolean;
}

/**
 * Par de botões de exportação. Mostra o motivo quando o servidor recusa, em vez
 * de falhar em silêncio: as recusas do relatório são específicas (seleção
 * vazia, id fora do quadro) e a pessoa precisa saber qual foi.
 */
export const BotoesExportacao = ({ aoExportar, desabilitado }: BotoesExportacaoProps) => {
  const [baixando, setBaixando] = useState<"pdf" | "excel" | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  const exportar = async (formato: "pdf" | "excel") => {
    setBaixando(formato);
    setErro(null);
    try {
      await aoExportar(formato);
    } catch (e) {
      setErro((await lerErroDeBlob(e)) ?? "Não foi possível gerar o arquivo.");
    } finally {
      setBaixando(null);
    }
  };

  const classe =
    "inline-flex items-center gap-2 px-3.5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => exportar("pdf")}
          disabled={desabilitado || baixando !== null}
          className={classe}
        >
          {baixando === "pdf" ? (
            <Download className="w-4 h-4 animate-pulse" />
          ) : (
            <FileText className="w-4 h-4" />
          )}
          PDF
        </button>
        <button
          type="button"
          onClick={() => exportar("excel")}
          disabled={desabilitado || baixando !== null}
          className={classe}
        >
          {baixando === "excel" ? (
            <Download className="w-4 h-4 animate-pulse" />
          ) : (
            <FileSpreadsheet className="w-4 h-4" />
          )}
          Excel
        </button>
      </div>
      {erro && <p className="text-xs text-red-700 max-w-md text-right">{erro}</p>}
    </div>
  );
};
